import { useEffect, useState } from "react"
import i18n from "../multilingual/config"
import { listAllReligionsService } from "../Service/ReligionService"
import { Dropdown } from "primereact/dropdown"

function ReligionsDropdown({field, errors}) {
    const [language, setLanguage] = useState(i18n.language)
    const [allReligions, setAllReligions] = useState()
    useEffect(()=>{
        setLanguage(i18n.language)
    },[i18n.language])
        
    useEffect(()=>{
        listAllReligions()
    },[])

    const listAllReligions = () => {
        listAllReligionsService(language).then(res=>{
            setAllReligions(res)
        })
    }

    const handleOptionLabel = (e) =>{
        return language === 'pt' ? e.name_pt_br : language === 'es' ? e.name_es : e.name
    }
    

    return (
        <Dropdown
            id={field?.value?.id}
            {...field}
            options={allReligions} optionLabel={handleOptionLabel} 
            className={errors.religion ? "p-invalid" : ""}
        />
    )
}

export default ReligionsDropdown